import Error from '@/common/errorData'
import CON from '../../constant'
import {
  http
} from './index'

const pasurl = CON.URL_DOWN
const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}
const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
// 接口提供者:
  studentIndex: (data) => getReq('/student-api/student/index.action', data).then(Error),
  getUser: (data) => getReq('/student-api/student/user/user.action', data).then(Error),
  logout: (data) => getReq('/student-api/student/login/logout.action', data).then(Error),
  registerUser: (data) => postReq('/subscriber-api/forgot/login/register.action', data)
}



// WEBPACK FOOTER //
// ./src/apis/student/home.js